import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { StoreStockSidebarType } from '@features/store-stock/store-stock';
import { StoresService } from '@features/stores-overview/service/stores.service';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@libs/overlay';
import { ProductDetailViewModel } from '@models/api-search.models';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { StoreStockListComponent } from '../store-stock-list/store-stock-list.component';
import { ReserveInStoreComponent } from '../reserve-in-store/reserve-in-store.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { DialogSidebarComponent } from '../../dialog/dialog-sidebar/dialog-sidebar.component';

@Component({
    selector: 'app-store-stock-container',
    templateUrl: './store-stock-container.component.html',
    styleUrls: ['./store-stock-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DialogSidebarComponent,
        NgIf,
        ReserveInStoreComponent,
        StoreStockListComponent,
        LoadingDotsComponent,
        AsyncPipe,
        TranslateSafePipe
    ]
})
export class StoreStockContainerComponent {
    constructor(
        @Inject(IMPACT_OVERLAY_DATA)
        public data: { stockSidebarType: StoreStockSidebarType; product: ProductDetailViewModel },
        public readonly storesService: StoresService,
        public readonly overlayRef: ImpactOverlayRef
    ) {}

    public closeOverlay(): void {
        this.overlayRef.close();
    }

    public setStockSidebarType(type: StoreStockSidebarType): void {
        this.data.stockSidebarType = type;
    }
}
